import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';

const YourTimeImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "11gyMvdFlJumLwR6pZJIMN" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
      align='center'
    >
      <ImageAndContent
        image={{
          imageProps: {
            image: images.featuredImage.gatsbyImageData,
            alt: 'How much time does it take?',
          },
          maxWidth: 650,
          radius: 'radius-2xl',
        }}
        contentPosition='right'
        content={
          <Stack
            padding={['spacing-none', 'spacing-4xl']}
            paddingMd='spacing-none'
            direction='column'
            gap='spacing-4xl'
          >
            <HeadingAndSupportingText
              maxWidth='width-2xl'
              gap='spacing-3xl'
              heading={{
                type: 'heading',
                text: 'How much time does it take?',
                size: 'lg',
                letterSpacing: -1,
                fontWeight: 'font-weight-semibold',
              }}
              subHeading={{
                text: 'Your Time',
                size: 'md',
                type: 'paragraph',
                color: 'text-brand-secondary',
                fontWeight: 'font-weight-semibold',
              }}
              subHeadingGap='spacing-lg'
              supportingText={{
                type: 'paragraph',
                size: 'xl',
                color: 'text-tertiary',
                children: (
                  <Stack
                    direction='column'
                    gap='spacing-lg'
                    as='span'
                  >
                    <Typography
                      as='span'
                      text='Our north star is 1 person, less than 1 hour a day.'
                    />
                    <Typography
                      as='span'
                      text='With Community Design™ and the right automations, Mighty handles onboarding, recognition, and re-engagement for you.'
                    />
                    <Typography
                      as='span'
                      text='You focus on your members. The platform does the rest.'
                    />
                  </Stack>
                ),
              }}
            />
            <Stack maxWidth='width-fit-content'>
              <Button
                variant='primary'
                size='xl'
                href='https://cohost.mn.co/?plan=free-trial'
              >
                Start Your Free Trial
              </Button>
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
};

export default YourTimeImageAndContent;
